import React from "react";
import "../../css/Inicio/calendario.css"; // O crea un CSS específico si lo prefieres

const CalendarioEventos = () => (
  <div className="calendario-eventos-bg">
    <div className="calendario-eventos-container">
      <h1>Calendario de Eventos</h1>
      <div className="calendario-eventos-iframe-wrapper">
        <iframe
          src="https://calendar.google.com/calendar/embed?src=c_8c0284a487be20d8e7189bb246410f25d49403db13a2d67da2b9da6263960edb%40group.calendar.google.com&amp;ctz=America%2FArgentina%2FCordoba"
          style={{ border: 0 }}
          width="100%"
          height="700"
          title="Calendario de eventos"
        ></iframe>
      </div>
    </div>
  </div>
);

export default CalendarioEventos;